import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const previewCornerRibbonIsVisibleSelector = createSelector(
    featureScopesSelector,
    (featureScopes) => featureScopes.includes('preview'),
)

export default previewCornerRibbonIsVisibleSelector
